import Resource from '@/api/resource';
import request from '@/utils/request';
class PermissionsResource extends Resource {
  constructor() {
    super('permissions');
  }

  // 获取权限列表
  getApi() {
    return request({
      url: `/${this.uri}`,
      method: 'GET',
    });
  }

  // 添加权限列表
  addApi(data) {
    return request({
      url: `/${this.uri}`,
      method: 'POST',
      data,
    });
  }

  // 修改权限列表
  editApi(data, permission_id) {
    return request({
      url: `/${this.uri}/${permission_id}/update`,
      method: 'POST',
      data,
    });
  }
}

export { PermissionsResource as default };
